const refundRouterList = [
  {
    path: '/refund/applyshoprefund',
    meta: { title: '申请退款' },
    component: () =>
      import(
        /* webpackChunkName: "applyshoprefund" */ '../../pages/refund/applyshoprefund.vue'
      ),
  },
  {
    path: '/refund/logshoprefund',
    meta: { title: '退款详情' },
    component: () =>
      import(
        /* webpackChunkName: "applyshoprefund" */ '../../pages/refund/logshoprefund.vue'
      ),
  },
  {
    path: '/refund/consulthistory',
    meta: { title: '协商历史' },
    component: () =>
      import(
        /* webpackChunkName: "consulthistory" */ '../../pages/refund/consulthistory.vue'
      ),
  },
  {
    name: 'shopRefund',
    path: '/refund/check',
    meta: { title: '售后处理', topNavName: '售后处理' },
    component: () =>
      import(
        /* webpackChunkName: "refundCheck" */ '../../pages/agent/shopRefund.vue'
      ),
  },
  {
    path: '/refund/check/detail',
    meta: { title: '退款详情' },
    component: () =>
      import(
        /* webpackChunkName: "refundCheckDetail" */ '../../pages/agent/shopRefundDetail.vue'
      ),
  },
  {
    path: '/refund/pickUpLink',
    meta: { title: '上门取件' },
    component: () =>
      import(
        /* webpackChunkName: "pickUpLink" */ '../../pages/refund/pickUpLink.vue'
      ),
  },
]
refundRouterList.forEach(item => {
  item.meta.isNotShare = true
})
export default refundRouterList
